function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from "react";
import { getAvailableFields } from "../utils";

/**
 * Tab Content Adder - Component for adding text or field content to a tab
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TabContentAdder = _ref => {
  let {
    tabId,
    allAvailableFields,
    isFieldInTab,
    isFieldInContainer,
    isFieldInOtherTab,
    onAddField
  } = _ref;
  const [selectedFieldId, setSelectedFieldId] = useState("");
  const handleAdd = () => {
    if (selectedFieldId) {
      onAddField(selectedFieldId);
      setSelectedFieldId("");
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "property-item property-item-spacing",
    children: [/*#__PURE__*/_jsx("label", {
      className: "property-label",
      children: "Add Field"
    }), /*#__PURE__*/_jsxs("div", {
      className: "property-flex-row",
      children: [/*#__PURE__*/_jsxs("select", {
        className: "property-input property-flex-row-item",
        value: selectedFieldId,
        onChange: e => setSelectedFieldId(e.target.value),
        children: [/*#__PURE__*/_jsx("option", {
          value: "",
          children: "Select a field..."
        }), allAvailableFields.map(fieldItem => {
          const isChecked = isFieldInTab(tabId, fieldItem.id);
          const isInOtherTab = isFieldInOtherTab(tabId, fieldItem.id);
          const isInOtherContainer = isFieldInContainer(fieldItem.id) && !isChecked && !isInOtherTab;
          const isDisabled = isChecked || isInOtherTab || isInOtherContainer;
          return /*#__PURE__*/_jsxs("option", {
            value: fieldItem.id,
            disabled: isDisabled,
            children: [fieldItem.label, " (", fieldItem.type, ")", isChecked ? " - Already added" : isInOtherTab ? " - In another tab" : isInOtherContainer ? " - In another container" : ""]
          }, fieldItem.id);
        })]
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "add-btn property-flex-row-button",
        onClick: handleAdd,
        disabled: !selectedFieldId,
        children: "Add"
      })]
    })]
  });
};

/**
 * Container Fields Property - Allows selecting fields/columns to be inside container fields
 * Hierarchy:
 * - Section: contains Columns only
 * - Columns: contains Fields directly
 * - Tabs: contains Fields directly (with tabs)
 * - Tables: contains Text/Field/Column from select box
 */
export const ContainerFieldsProperty = _ref2 => {
  let {
    field,
    fields,
    selectedField,
    updateField
  } = _ref2;
  // Only show for container field types
  const containerTypes = ["tabs"];
  if (!containerTypes.includes(field.type)) {
    return null;
  }

  // Helper to check if a field is already in a container
  const isFieldInContainer = fieldId => {
    return fields.some(f => {
      if (containerTypes.includes(f.type) && f.id !== selectedField) {
        // Check tabContent (for tabs)
        if (f.type === "tabs" && f.tabContent) {
          const tabContent = f.tabContent;
          const allFieldIds = Object.values(tabContent).flat().filter(item => item.type === "field").map(item => item.value);
          if (allFieldIds.includes(fieldId)) {
            return true;
          }
        }
      }
      return false;
    });
  };
  if (field.type === "tabs") {
    // Tabs: special handling with tab configuration
    return /*#__PURE__*/_jsx(TabsProperty, {
      field: field,
      fields: fields,
      selectedField: selectedField,
      updateField: updateField,
      isFieldInContainer: isFieldInContainer,
      containerTypes: containerTypes
    });
  }
  const selectedIds = field.sections || [];
  const handleToggle = itemId => {
    const current = field.sections || [];
    const isAdding = !current.includes(itemId);
    if (isAdding) {
      // When adding, remove from other containers first
      const newSections = [...current, itemId];
      updateField(selectedField, {
        sections: newSections
      });

      // Remove from other containers
      fields.forEach(f => {
        if (f.id !== selectedField && containerTypes.includes(f.type)) {
          const otherSections = f.sections || [];
          if (otherSections.includes(itemId)) {
            const updatedSections = otherSections.filter(id => id !== itemId);
            updateField(f.id, {
              sections: updatedSections
            });
          }
          // Also check tabContent for tabs
          if (f.type === "tabs" && f.tabContent) {
            const tabContent = _objectSpread({}, f.tabContent);
            let updated = false;
            Object.keys(tabContent).forEach(tabId => {
              tabContent[tabId] = tabContent[tabId].filter(item => !(item.type === "field" && item.value === itemId));
              if (tabContent[tabId].length !== (f.tabContent[tabId]?.length || 0)) {
                updated = true;
              }
            });
            if (updated) {
              updateField(f.id, {
                tabContent
              });
            }
          }
        }
      });
    } else {
      // When removing, just remove from current container
      const newSections = current.filter(id => id !== itemId);
      updateField(selectedField, {
        sections: newSections
      });
    }
  };
  const label = "Fields in Tabs";
  return /*#__PURE__*/_jsxs("div", {
    className: "property-section",
    children: [/*#__PURE__*/_jsx("label", {
      className: "section-label",
      children: label
    }), /*#__PURE__*/_jsx("div", {
      className: "container-fields-section",
      children: availableItems.length === 0 ? /*#__PURE__*/_jsx("p", {
        className: "help-text",
        children: field.type === "section" || field.type === "tabs" ? "You should add columns to appear here" : "No fields available to add"
      }) : availableItems.map(item => /*#__PURE__*/_jsxs("label", {
        className: "checkbox-label",
        children: [/*#__PURE__*/_jsx("input", {
          type: "checkbox",
          checked: selectedIds.includes(item.id),
          onChange: () => handleToggle(item.id)
        }), /*#__PURE__*/_jsxs("span", {
          children: [item.label, " (", item.type, ")"]
        })]
      }, item.id))
    })]
  });
};

/**
 * Tabs Property - Special handling for tabs with tab configuration and content type (text/field)
 */
const TabsProperty = _ref3 => {
  let {
    field,
    fields,
    selectedField,
    updateField,
    isFieldInContainer,
    containerTypes
  } = _ref3;
  const tabs = field.tabs || [{
    id: "tab1",
    label: "Tab 1"
  }];
  const tabContent = field.tabContent || {}; // { tabId: [{ type: 'text'|'field', value: string, id?: string }] }

  // Get all available fields - exclude those already in other containers
  const allAvailableFields = fields.filter(f => {
    if (f.id === selectedField) return false;
    if (containerTypes.includes(f.type)) return false;
    // Exclude fields that are in other containers (tabs or tables)
    return !isFieldInContainer(f.id);
  }).map(f => ({
    id: f.id,
    label: f.label || f.name || "Unnamed Field",
    type: f.type
  }));
  const updateTab = (index, key, value) => {
    const newTabs = [...tabs];
    newTabs[index] = _objectSpread(_objectSpread({}, newTabs[index]), {}, {
      [key]: value
    });
    updateField(selectedField, {
      tabs: newTabs
    });
  };
  const addTab = () => {
    const newTabId = `tab${tabs.length + 1}`;
    const newTabs = [...tabs, {
      id: newTabId,
      label: `Tab ${tabs.length + 1}`
    }];
    updateField(selectedField, {
      tabs: newTabs
    });
  };
  const removeTab = index => {
    const newTabs = tabs.filter((_, i) => i !== index);
    const tabContent = field.tabContent || {};
    const newTabContent = _objectSpread({}, tabContent);
    const tabId = tabs[index].id;
    const tabItems = newTabContent[tabId] || [];

    // Revert fields back to main container when tab is removed
    tabItems.forEach(item => {
      if (item.type === "field") {
        // Remove from other containers first
        fields.forEach(f => {
          if (f.id !== selectedField && f.type !== "tabs") {
            if (f.type === "section") {
              const sections = f.sections || [];
              if (sections.includes(item.value)) {
                const updatedSections = sections.filter(id => id !== item.value);
                updateField(f.id, {
                  sections: updatedSections
                });
              }
            }
          }
        });
      }
    });

    // Remove the tab's content
    delete newTabContent[tabId];
    updateField(selectedField, {
      tabs: newTabs,
      tabContent: newTabContent
    });
  };
  const handleFieldToggle = (tabId, fieldId, checked) => {
    const currentTabContent = _objectSpread({}, tabContent);
    const tabItems = currentTabContent[tabId] || [];
    if (checked) {
      // Add field to tab
      const newContent = {
        type: "field",
        value: fieldId,
        id: fieldId
      };

      // First, remove field from other tabs within the same tabs component
      Object.keys(currentTabContent).forEach(otherTabId => {
        if (otherTabId !== tabId) {
          currentTabContent[otherTabId] = (currentTabContent[otherTabId] || []).filter(item => !(item.type === "field" && item.value === fieldId));
        }
      });
      currentTabContent[tabId] = [...tabItems, newContent];
      updateField(selectedField, {
        tabContent: currentTabContent
      });

      // Remove from other containers (including main component)
      fields.forEach(f => {
        if (f.id !== selectedField) {
          if (f.type === "section") {
            const sections = f.sections || [];
            if (sections.includes(fieldId)) {
              const updatedSections = sections.filter(id => id !== fieldId);
              updateField(f.id, {
                sections: updatedSections
              });
            }
          }
          if (f.type === "tabs" && f.tabContent) {
            const otherTabContent = _objectSpread({}, f.tabContent);
            let updated = false;
            Object.keys(otherTabContent).forEach(otherTabId => {
              otherTabContent[otherTabId] = otherTabContent[otherTabId].filter(item => !(item.type === "field" && item.value === fieldId));
              if (otherTabContent[otherTabId].length !== (f.tabContent[otherTabId]?.length || 0)) {
                updated = true;
              }
            });
            if (updated) {
              updateField(f.id, {
                tabContent: otherTabContent
              });
            }
          }
          if (f.type === "columns") {
            const sections = f.sections || [];
            if (sections.includes(fieldId)) {
              const updatedSections = sections.filter(id => id !== fieldId);
              updateField(f.id, {
                sections: updatedSections
              });
            }
          }
        }
      });
    } else {
      // Remove field from tab
      currentTabContent[tabId] = tabItems.filter(item => !(item.type === "field" && item.value === fieldId));
      updateField(selectedField, {
        tabContent: currentTabContent
      });
    }
  };
  const isFieldInTab = (tabId, fieldId) => {
    const tabItems = tabContent[tabId] || [];
    return tabItems.some(item => item.type === "field" && item.value === fieldId);
  };

  // Check if field is in any other tab (not the current one)
  const isFieldInOtherTab = (currentTabId, fieldId) => {
    return Object.keys(tabContent).some(tabId => {
      if (tabId === currentTabId) return false; // Skip current tab
      const tabItems = tabContent[tabId] || [];
      return tabItems.some(item => item.type === "field" && item.value === fieldId);
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "property-section",
    children: [/*#__PURE__*/_jsx("label", {
      className: "section-label",
      children: "Tabs Configuration"
    }), /*#__PURE__*/_jsxs("div", {
      className: "tabs-config-section",
      children: [tabs.map((tab, index) => {
        const tabItems = tabContent[tab.id] || [];
        return /*#__PURE__*/_jsxs("div", {
          className: "property-box",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "property-item property-item-spacing-sm",
            children: [/*#__PURE__*/_jsx("label", {
              className: "property-label",
              children: "Tab Name"
            }), /*#__PURE__*/_jsx("input", {
              type: "text",
              value: tab.label,
              onChange: e => updateTab(index, "label", e.target.value),
              placeholder: "Tab Name",
              className: "property-input"
            })]
          }), /*#__PURE__*/_jsx(TabContentAdder, {
            tabId: tab.id,
            allAvailableFields: allAvailableFields,
            isFieldInTab: isFieldInTab,
            isFieldInContainer: isFieldInContainer,
            isFieldInOtherTab: isFieldInOtherTab,
            onAddField: fieldId => handleFieldToggle(tab.id, fieldId, true)
          }), tabItems.length > 0 && /*#__PURE__*/_jsxs("div", {
            className: "property-content-items",
            children: [/*#__PURE__*/_jsx("label", {
              className: "property-text-item-label",
              children: "Content Items"
            }), tabItems.map(content => /*#__PURE__*/_jsxs("div", {
              className: "property-text-item",
              children: [/*#__PURE__*/_jsx("span", {
                children: (() => {
                  const f = allAvailableFields.find(f => f.id === content.value);
                  return f ? `Field: ${f.label} (${f.type})` : `Field: ${content.value}`;
                })()
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                onClick: () => handleFieldToggle(tab.id, content.value, false),
                className: "remove-condition-btn remove-btn-sm",
                children: "\xD7"
              })]
            }, content.id))]
          }), tabs.length > 1 && /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: () => removeTab(index),
            className: "remove-btn remove-btn-top-margin",
            children: "Remove Tab"
          })]
        }, tab.id);
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: addTab,
        className: "add-btn",
        children: "+ Add Tab"
      })]
    })]
  });
};